<div class="travel-guide-container">

    <ng-container *ngIf="loading | async">
        <div class="spacer"></div>
        <div class="loading-state">
            <div class="spinner"></div>
            <p>Loading travel guide...</p>
        </div>
    </ng-container>

    <ng-container *ngIf="error | async">
        <!-- <div class="error-state">
            <h3>Oops! Something went wrong</h3>
            <p>We couldn't load the travel guide at this time. Please try again later.</p>
        </div> -->
    </ng-container>

    <ng-container *ngIf="!(loading | async) && !(error | async) && travelGuideData">
        <div class="spacer"></div>
        
        <div class="subheader" style="margin-bottom: 1rem;">
            City Guide
        </div>
       
        <div class="table-of-contents mobile-scroll">
            <h3>Table of Contents</h3>
            <div class="toc-grid">
                <a (click)="scrollToSection('things-to-see', $event)" href="#things-to-see" class="toc-item">
                    <span class="number">1.</span>
                    <span class="text">
                        <ng-container i18n>Things to See and Do</ng-container>
                    </span>
                </a>
                <a (click)="scrollToSection('safety', $event)" href="#safety" class="toc-item">
                    <span class="number">2.</span>
                    <span class="text">
                        <ng-container i18n>How to Stay Safe</ng-container>
                    </span>
                </a>
                <a (click)="scrollToSection('where-to-stay', $event)" href="#where-to-stay" class="toc-item">
                    <span class="number">3.</span>
                    <span class="text">
                        <ng-container i18n>Where to Stay</ng-container>
                    </span>
                </a>
                <a (click)="scrollToSection('getting-around', $event)" href="#getting-around" class="toc-item">
                    <span class="number">4.</span>
                    <span class="text">
                        <ng-container i18n>How to Get Around</ng-container>
                    </span>
                </a>
                <a (click)="scrollToSection('local-tips', $event)" href="#local-tips" class="toc-item">
                    <span class="number">5.</span>
                    <span class="text">
                        <ng-container i18n>Local Tips & Etiquette</ng-container>
                    </span>
                </a>
                <a (click)="scrollToSection('food', $event)" href="#food" class="toc-item">
                    <span class="number">6.</span>
                    <span class="text">
                        <ng-container i18n>Local Food & Dishes</ng-container>
                    </span>
                </a>
                <a (click)="scrollToSection('nightlife', $event)" href="#nightlife" class="toc-item">
                    <span class="number">7.</span>
                    <span class="text">
                        <ng-container i18n>Nightlife</ng-container>
                    </span>
                </a>
                <a (click)="scrollToSection('digital-nomads', $event)" href="#digital-nomads" class="toc-item">
                    <span class="number">8.</span>
                    <span class="text">
                        <ng-container i18n>Digital Nomad Spots</ng-container>
                    </span>
                </a>
                <a (click)="scrollToSection('seasonal', $event)" href="#seasonal" class="toc-item">
                    <span class="number">9.</span>
                    <span class="text">
                        <ng-container i18n>Seasonal Highlights</ng-container>
                    </span>
                </a>
                <a (click)="scrollToSection('transport', $event)" href="#transport" class="toc-item">
                    <span class="number">10.</span>
                    <span class="text">
                        <ng-container i18n>Airport Transport</ng-container>
                    </span>
                </a>
            </div>
        </div>

        <div class="guide-sections">
            <section id="things-to-see">
                <h3>
                    <ng-container i18n>Things to See and Do</ng-container>
                </h3>
                <p>{{getLocalizedText(travelGuideData.describe_area)}}</p>
            </section>

            <section id="safety">
                <h3>
                    <ng-container i18n>How to Stay Safe</ng-container>
                </h3>
                <p>{{getLocalizedText(travelGuideData.hostel_safety)}}</p>
                <p *ngIf="travelGuideData.emergency_info">
                    <ng-container i18n>Emergency Information:</ng-container> {{getLocalizedText(travelGuideData.emergency_info)}}
                </p>
            </section>

            <section id="where-to-stay">
                <h3>
                    <ng-container i18n>Where to Stay</ng-container>
                </h3>
                <p>{{getLocalizedText(travelGuideData.top_recommendations)}}</p>
            </section>

            <section id="getting-around">
                <h3>
                    <ng-container i18n>How to Get Around</ng-container>
                </h3>
                <p>{{getLocalizedText(travelGuideData.getting_around)}}</p>
                <p>
                    <ng-container i18n>Local Transport:</ng-container> {{getLocalizedText(travelGuideData.local_transport)}}
                </p>
                <p>
                    <ng-container i18n>Ticket Information:</ng-container> {{getLocalizedText(travelGuideData.ticket_purchase_info)}}
                </p>
            </section>

            <section id="local-tips">
                <h3>
                    <ng-container i18n>Local Tips & Etiquette</ng-container>
                </h3>
                <p>{{getLocalizedText(travelGuideData.local_etiquette)}}</p>
                <p *ngIf="travelGuideData.cash_importance">
                    <ng-container i18n>Cash Usage:</ng-container> {{getLocalizedText(travelGuideData.cash_importance)}}
                </p>
                <p *ngIf="travelGuideData.haggling_advice">
                    <ng-container i18n>Haggling Tips:</ng-container> {{getLocalizedText(travelGuideData.haggling_advice)}}
                </p>
            </section>

            <section id="food">
                <h3>
                    <ng-container i18n>Local Food & Dishes</ng-container>
                </h3>
                <p>{{getLocalizedText(travelGuideData.local_dishes)}}</p>
            </section>

            <section id="nightlife">
                <h3>
                    <ng-container i18n>Nightlife</ng-container>
                </h3>
                <p>{{getLocalizedText(travelGuideData.nightlife_description)}}</p>
            </section>

            <section id="digital-nomads">
                <h3>
                    <ng-container i18n>Digital Nomad Spots</ng-container>
                </h3>
                <p>{{getLocalizedText(travelGuideData.digital_nomad_spots)}}</p>
            </section>

            <section id="seasonal">
                <h3>
                    <ng-container i18n>Seasonal Highlights</ng-container>
                </h3>
                <p>{{getLocalizedText(travelGuideData.seasonal_highlight)}}</p>
            </section>

            <section id="transport">
                <h3>
                    <ng-container i18n>Airport Transport</ng-container>
                </h3>
                <p>{{getLocalizedText(travelGuideData.to_and_from_airport)}}</p>
            </section>
        </div>
    </ng-container>
</div>